/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Type_AllInputs */

const en_explorer_search_type_all = /** @type {(inputs: Explorer_Search_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all`)
};

const fr_explorer_search_type_all = /** @type {(inputs: Explorer_Search_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all`)
};

const de_explorer_search_type_all = /** @type {(inputs: Explorer_Search_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all`)
};

const it_explorer_search_type_all = /** @type {(inputs: Explorer_Search_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all`)
};

const ru_explorer_search_type_all = /** @type {(inputs: Explorer_Search_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all`)
};

const es_explorer_search_type_all = /** @type {(inputs: Explorer_Search_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all`)
};

const zh_cn2_explorer_search_type_all = /** @type {(inputs: Explorer_Search_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all`)
};

const ja_explorer_search_type_all = /** @type {(inputs: Explorer_Search_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all`)
};

const hi_explorer_search_type_all = /** @type {(inputs: Explorer_Search_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all`)
};

const pt_pt2_explorer_search_type_all = /** @type {(inputs: Explorer_Search_Type_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all`)
};

/**
* | output |
* | --- |
* | "all" |
*
* @param {Explorer_Search_Type_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_type_all = /** @type {((inputs?: Explorer_Search_Type_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Type_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_type_all(inputs)
	if (locale === "de") return de_explorer_search_type_all(inputs)
	if (locale === "it") return it_explorer_search_type_all(inputs)
	if (locale === "ru") return ru_explorer_search_type_all(inputs)
	if (locale === "es") return es_explorer_search_type_all(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_type_all(inputs)
	if (locale === "ja") return ja_explorer_search_type_all(inputs)
	if (locale === "hi") return hi_explorer_search_type_all(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_type_all(inputs)
	return en_explorer_search_type_all(inputs)
});